var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center pr-0 pl-0",attrs:{"fluid":""}},_vm._l((_vm.$store.getters.assinaturas),function(assinatura){return _c('assinatura-box',{key:assinatura.id,attrs:{"item":assinatura}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }